import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CustomRightPanelService } from './custom-right-panel.service';

@Component({
  selector: 'app-custom-right-panel-heading',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './custom-right-panel-heading.component.html',
  styleUrls: ['./custom-right-panel-heading.component.scss']
})
export class CustomRightPanelHeadingComponent {
  @Input() keyName?: string;
  currentRoute: string = '';

  constructor(public rightPanelConfig: CustomRightPanelService,
    private router: Router
  ) {
    this.currentRoute = this.router.url;
  }

  // Helper method to safely access the config
  getPanelConfig() {
    return this.keyName ? this.rightPanelConfig[this.keyName] : null;
  }
}